export default "__VITE_ASSET__d3d3274e__"